module.exports = __webpack_public_path__ + "assets/cerapro-medium-webfont.523aa64b.woff2";